//#region src/types/HostActionIntent.ts
var e = /* @__PURE__ */ function(e) {
	return e.Blocker = "BLOCKER", e.Decision = "DECISION", e.Opportunity = "OPPORTUNITY", e.Waiting = "WAITING", e;
}({}), t = {
	[e.Blocker]: 0,
	[e.Decision]: 1,
	[e.Opportunity]: 2,
	[e.Waiting]: 3
};
//#endregion
export { t as HOST_ACTION_INTENT_ORDER, e as HostActionIntent };
